import { mergeAttributes } from '@tiptap/core';
import Paragraph, { ParagraphOptions } from '@tiptap/extension-paragraph';
import { findLargestChildMarkFontSize } from 'widgets/TextBasedWidgets/common/TextBasedWidgets.helpers';

interface CustomParagraphOptions extends ParagraphOptions {
  // p for normal text and span for title/headers (p can't be a descendant of h1, h2, etc)
  renderTag: 'p' | 'span';
}

// This extension extends the base tiptap paragraph extension
// with a font size attribute that is the largest font size of its children or the attribute fontSize for empty lines
// So that the line height of the paragraph is correct & that empty lines have the correct font size
export const CustomParagraph = Paragraph.extend<CustomParagraphOptions>({
  addOptions() {
    return {
      HTMLAttributes: {},
      renderTag: 'p',
    };
  },

  group: 'block',
  content: 'inline*',

  parseHTML() {
    const renderTag = this.options.renderTag;
    return [{ tag: renderTag }];
  },

  addAttributes() {
    return {
      fontSize: { default: null },
    };
  },

  renderHTML({ HTMLAttributes, node }) {
    // The font size of a paragraph is the largest font size of its children
    // If no children -> use the attribute fontSize (e.g. empty line / new line)
    const fontSize = findLargestChildMarkFontSize(node);

    // no need to add these attributes to the element
    delete HTMLAttributes.fontSize;
    delete HTMLAttributes.renderTag;

    const textTag = this.options.renderTag;
    const className = textTag === 'span' ? 'display-block' : null;
    const attributes = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      class: className,
      style: `font-size: ${fontSize}px;`,
    });

    return [textTag, attributes, 0];
  },
});
